<template>
  <div class="card-body">
    <h4 id="header-vendor" class="card-title card-collapse">
      <span
        class="pointer"
        @click="
          vendorComponentModel.collapseState = !vendorComponentModel.collapseState
        "
        >Vendor Information</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="vendorComponentModel.validateState == false"
          @click="
            vendorComponentModel.collapseState = !vendorComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            vendorComponentModel.collapseState = !vendorComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="vendorComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-vendor"
      v-model="vendorComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <form
          @submit.prevent="
            onGetVendorDataAsync()
            isOnClick = true
          "
          @reset="onReset"
        >
          <div class="pt-3">
            <div class="row">
              <div class="col-12">
                <div class="border-top pb-4"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-row form-group">
                  <label class="col-lg-4 col-xl-3 col-form-label" for="code"
                    >รหัสผู้ขาย</label
                  >
                  <div class="col-sm-4">
                    <validationProvider
                      v-slot="{ errors }"
                      name="code"
                      :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                    >
                      <div role="group" class="input-group">
                        <input
                          id="code"
                          name="code"
                          type="text"
                          class="form-control"
                          v-model="vendorComponentModel.model.code"
                          :class="{ 'is-invalid': errors.length }"
                          :disabled="
                            dataPermissions.find(
                              f => f.name === 'vendor_information'
                            ).isEditable === false ||
                              (userInfo.user_type === 'Vendor' &&
                                GET_VENDOR_SELECTED &&
                                (GET_VENDOR_SELECTED.type === 'OFMStock' ||
                                  GET_VENDOR_SELECTED.type === 'DropShip'))
                          "
                          
                          @blur="onGetVendorDataAsync()
                                  isOnClick = true"
                        />
                        <span
                          class="input-group-append pointer"
                          @click="
                            onGetVendorDataAsync()
                            isOnClick = true
                          "
                        >
                          <span type="a" class="input-group-text btn btn-light">
                            <i class="bx bx-search" />
                          </span>
                        </span>
                      </div>
                      <span
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        {{ errors[0] }}
                      </span>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="display_name_th"
                    >ชื่อผู้ขาย</label
                  >
                  <div class="col-lg col-12 mt-auto mb-auto">
                    <span class="badge-lang">TH</span
                    >{{
                      vendorComponentModel.model.display_name &&
                      vendorComponentModel.model.display_name.th
                        ? vendorComponentModel.model.display_name.th
                        : '-'
                    }}
                  </div>
                </div>
                <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="display_name_en"
                  ></label>
                  <div class="col-lg col-12 mt-auto mb-auto">
                    <span class="badge-lang">EN</span>
                    {{
                      vendorComponentModel.model.display_name &&
                      vendorComponentModel.model.display_name.en
                        ? vendorComponentModel.model.display_name.en
                        : '-'
                    }}
                  </div>
                </div>
                <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="display_name_en"
                    >ประเภทผู้ขาย</label
                  >
                  <div class="col-lg col-12 mt-auto mb-auto">
                    <span
                      v-if="vendorComponentModel.model.vendor_type"
                      class="label"
                      :class="
                        'label-' +
                          vendorComponentModel.model.vendor_type.toLowerCase()
                      "
                      v-html="vendorComponentModel.model.vendor_type"
                    ></span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="form-row">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="display_name_en"
                    >สถานะผู้ขาย</label
                  >
                  <div class="col-lg col-12 mt-auto mb-auto">
                    <span
                      v-if="vendorComponentModel.model.vendor_status"
                      class="label"
                      :class="
                        'label-' +
                          vendorComponentModel.model.vendor_status.toLowerCase()
                      "
                      v-html="vendorComponentModel.model.vendor_status"
                    ></span>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import vendorService from '@/helpers/service/vendor-service'
import { eventBus } from '@/main.js'
import { getUserInfo } from '@/helpers/utils/jwt'
import { authComputed } from '@/state/helpers'
export default {
  name: 'Vendor',
  props: {
    value: {
      type: Object,
      default: () => {
        return this.vendorComponentModel
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  data() {
    return {
      vendorComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          id: '',
          code: '',
          display_name: { en: '', th: '' },
          vendor_type: '',
          vendor_status: '',
          lead_time: 0,
          is_consignment: false,
          is_import: false,
          discount_rate_1: 0.0,
          vat_rate: 0,
        },
      },
      isFirstWatchValue: true,
      // componentModelOriginal: {},
      permissions: [
        {
          name: 'vendor_information',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      isOnClick: false,
    }
  },
  created() {
    if (this.value.model.id !== '') {
      this.vendorComponentModel = this.value
      this.$nextTick(() => {
        this.onGetVendorDataAsync()
      })
    }

    eventBus.$on('collapse-vendor', () => {
      this.vendorComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  mounted() {
    if (
      this.userInfo.user_type === 'Vendor' &&
      this.value.model.code === '' &&
      this.GET_VENDOR_SELECTED &&
      (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
        this.GET_VENDOR_SELECTED.type === 'DropShip')
    ) {
      this.$nextTick(() => {
        this.isOnClick = true
        this.onGetVendorByIdAsync()
      })
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val && val.model.code !== '' && this.isFirstWatchValue) {
          this.isFirstWatchValue = false
          if (
            this.userInfo.user_type === 'Vendor' &&
            this.GET_VENDOR_SELECTED &&
            (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
              this.GET_VENDOR_SELECTED.type === 'DropShip')
          ) {
            this.$nextTick(() => {
              this.onGetVendorByIdAsync()
            })
          } else {
            this.vendorComponentModel = val
            this.$nextTick(() => {
              console.log('isOnClick1', this.isOnClick)
              this.onGetVendorDataAsync()
            })
          }
        }
      },
      deep: true,
    },
    //     GET_VENDOR_SELECTED: {
    //       handler(val) {
    //         if (
    //           this.userInfo.user_type === 'Vendor' &&
    //           this.GET_VENDOR_SELECTED &&
    //           (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
    //             this.GET_VENDOR_SELECTED.type === 'DropShip')
    //         ) {
    //           this.$nextTick(async () => {
    //             await this.$utils
    //               .confirmAlertDisplay(
    //                 `หากเปลี่ยน Vendor จะทำให้งานที่กำลังทำค้างอยู่หายไปทั้งหมด
    // ต้องการเปลี่ยน Vendor ใช่หรือไม่ ?`,
    //                 ''
    //               )
    //               .then(result => {
    //                 if (result) {
    //                   this.$router.push({
    //                     path: `/product/registers`,
    //                   })
    //                   // this.onGetVendorByIdAsync()
    //                 }
    //               })
    //           })
    //         }
    //       },
    //       deep: true,
    //     },
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  methods: {
    modelChanged() {
      this.vendorComponentModel.isPayloadChanged = true
      this.$emit('input', this.vendorComponentModel)
    },
    async onGetVendorByIdAsync() {
      let result = await vendorService.getVendorMasterDetailAsync(
        this.GET_VENDOR_SELECTED.id
      )
      if (result.status === 200) {
        if (result.data) {
          let vendorData = result.data
          if (vendorData.status == 'Active' || vendorData.status == 'Suspend') {
            this.vendorComponentModel.model.id = vendorData.id
            this.vendorComponentModel.model.display_name =
              vendorData.display_name
            this.vendorComponentModel.model.vendor_type = vendorData.type
            this.vendorComponentModel.model.vendor_status = vendorData.status
            this.vendorComponentModel.model.lead_time = vendorData.lead_time
            this.vendorComponentModel.model.is_consignment =
              vendorData.is_consignment
            this.vendorComponentModel.model.is_import = vendorData.is_import
            this.vendorComponentModel.model.discount_rate_1 =
              vendorData.discount.rate_1
            this.vendorComponentModel.model.code = vendorData.vendor_partners.find(
              f => f.partner === 'OFM'
            ).code
            this.vendorComponentModel.model.vat_rate = vendorData.vat_rate
            this.modelChanged()
            console.log('isOnClick', this.isOnClick)
            // console.log('isFirstWatchValue', this.isFirstWatchValue)
            if (this.isOnClick) {
              eventBus.$emit('onSetDefault', {type :'Product Type' , value : vendorData.type})
              this.isOnClick = false
            }
          } else {
            this.$utils.notification(
              'warning',
              `ผู้ขายมีสถานะเป็น (${vendorData.status}) ไม่สามารถทำการ Register ข้อมูลสินค้าได้`,
              2000
            )
          }
        } else {
          this.$utils.notification(
            'warning',
            `ไม่พบผู้ขายที่มีรหัส (${this.vendorComponentModel.model.code.trim()}) ในระบบ PIM`,
            2000
          )
        }
      } else {
        // eslint-disable-next-line no-console
        console.log('error', result.response.data.message)
      }

      this.$nextTick(() => {
        this.onSubmit()
      })
    },
    async onGetVendorDataAsync() {
      if (
        this.vendorComponentModel.model.code.trim() !== '' &&
        this.vendorComponentModel.model.code.trim().length >= 5
      ) {
        let params = new URLSearchParams()
        params.append(
          'keyword',
          this.vendorComponentModel.model.code.trim() || ''
        )
        let result = await vendorService.getVendorMasterListAsync(params)
        if (result.status === 200) {
          if (result.data.items && result.data.items.length > 0) {
            let vendorData = result.data.items[0]
            if (
              vendorData.status == 'Active' ||
              vendorData.status == 'Suspend'
            ) {
              this.vendorComponentModel.model.id = vendorData.id
              this.vendorComponentModel.model.display_name =
                vendorData.display_name
              this.vendorComponentModel.model.vendor_type = vendorData.type
              this.vendorComponentModel.model.vendor_status = vendorData.status
              this.vendorComponentModel.model.lead_time = vendorData.lead_time
              this.vendorComponentModel.model.is_consignment =
                vendorData.is_consignment
              this.vendorComponentModel.model.is_import = vendorData.is_import
              this.vendorComponentModel.model.discount_rate_1 =
                vendorData.discount.rate_1
              this.vendorComponentModel.model.vat_rate = vendorData.vat_rate
              // this.vendorComponentModel.vendor.id = this.vendorComponentModel.model.code
              console.log('isOnClick', this.isOnClick)
              // console.log('isFirstWatchValue', this.isFirstWatchValue)
              if (this.isOnClick || this.isFirstLoad) {
                console.log('click')
                this.isFirstLoad = false
                eventBus.$emit('onSetDefault', {type :'Product Type' , value : vendorData.type})
                this.isOnClick = false
              }
            } else {
              this.$utils.notification(
                'warning',
                `ผู้ขายมีสถานะเป็น (${vendorData.status}) ไม่สามารถทำการ Register ข้อมูลสินค้าได้`,
                2000
              )
            }
          } else {
            this.$utils.notification(
              'warning',
              `ไม่พบผู้ขายที่มีรหัส (${this.vendorComponentModel.model.code.trim()}) ในระบบ PIM`,
              2000
            )
          }
        } else {
          // eslint-disable-next-line no-console
          console.log('error', result.response.data.message)
        }
      }

      this.$nextTick(() => {
        this.onSubmit()
      })
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        if (result) {
          this.vendorComponentModel.validateState = true
        } else {
          this.vendorComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
  },
}
</script>
